
<template>
  <div class="products">
    <Head :info="headInfo"></Head>
    <div class="container">
        <div class="psi">
            <!-- <img src="../../assets/images/one-share.png" alt=""> -->
        </div>
       <!--  <div class="chain">
            <img src="../../assets/images/one-share.png" alt="">
        </div> -->
        <div class="erp">
            <!-- <img src="../../assets/images/one-share.png" alt=""> -->
        </div>
    </div>
    <div class="bottom">
        <div class="bottom-btn">
            <img v-if="!RecID" src="../../assets/images/share.png" alt="">
            <span v-if="!RecID" @click="goshare()">分享</span>
            <span  v-if="RecID" @click="goRegister()">去注册</span>
        </div>
    </div>
  </div>
</template>

<script type="text/babel">

import Head from '@/component_basics/Head'
import Cell from '@/component_basics/Cell'
import jsSha from 'jssha'
import {ls} from '@/utils/localStorage'


// 组件
export default {
  name: 'products',
  components: {Head,Cell},
  data() {
    return {
        headInfo:{
            name: '我们的产品'
        },
        disabled:true, 
        value:'',
        checked:'',
        RecID: '',
        wxInfo:{},
        userInfo: {}
        
    };
  },
  beforeRouteEnter(to, from, next) {
      next(vm => {
            var UA = navigator.userAgent;
            if (UA.match(/iPad/) || UA.match(/iPhone/) || UA.match(/iPod/)) {
                if (!ls.get('isReload')) {
            ls.set('isReload', window.location.href)
            // 微信分享需要重新设置URL
            window.location.href = window.location.href
            }
        }
        
      })
  },
  created() {

      // 客户通过分享进来会带上RecID
      this.RecID = this.$route.query.RecID||''
      this.saleId = this.$route.query.saleId||''
    this.userInfo = ls.get('userInfo')
    //   this.share()
    this.getAppId()
  },
 mounted() {
 },
  methods: {
      share() {
            wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                    //分享朋友
                wx.updateAppMessageShareData({ 
                   title: '网上管家婆产品', // 分享标题
                   desc: '立即成为网上管家婆合伙人', // 分享描述
                   link: `http://${location.host}/index.html#/products?RecID=${ls.get('refereeId')}&saleId=${this.userInfo.saleId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                   imgUrl: 'http://refereestage.zhangyuxia.com.cn/img/psi.27423ded.png', // 分享图标
                })
                    // 分享朋友圈
        //             wx.onMenuShareTimeline({
        //                 title: '编程是AI时代基础技能，孩子的编程作品，锦城社区环保主题编程大赛', // 分享标题
        //                 desc: that.state.projectInfo.desc, // 分享描述
        //            link: `http://${location.host}/#/moblie?id=${that.state.id}&user=${that.state.userId}`
        //     })
        })
      },
      getAppId() {
          this.$services.getAppId().then(res=> {
              this.wxInfo = res.data
              this.getWxCofig()
          })
      },
    getWxCofig() {
          this.$services.getConfig({method:'get',params:{type:'jsapi'}}).then(res=> {
              this.wx(res)
          })
      },
    wx(res) {
           let _this = this
            let nonce = Math.random().toString(36).substr(2, 15);
            this.nonceString = nonce 
            let time = parseInt(new Date().getTime() / 1000)
            if(window.location.href.indexOf('from') != -1 || window.location.href.indexOf('isappinstalled') != -1){
                // 二次分享url重定向 - 需要截取一次分享后微信自动拼接的url参数&from=singlemessage&isappinstalled=0
                window.location.href = window.location.href.split('?')[0]+"#"+window.location.href.split('#')[1];  // 这里的split中的字符串会变换（?或&），主要看自己的url
            }
            let str = `jsapi_ticket=${res.data}&noncestr=${nonce}&timestamp=${time}&url=${location.href.split('#')[0]}`
            let sign = new jsSha(str,'TEXT')
            wx.config({
                debug:false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。

                appId: _this.wxInfo.appId,
                timestamp: time, // 必填，生成签名的时间戳
                nonceStr: nonce, // 必填，生成签名的随机串
                signature: sign.getHash('SHA-1', 'HEX'),// 必填，签名
                jsApiList: ['onMenuShareAppMessage','onMenuShareTimeline','updateAppMessageShareData','updateTimelineShareData','onMenuShareTimeline'], // 必填，需要使用的JS接口列表
                
              });
             wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                //分享朋友
                wx.updateAppMessageShareData({ 
                      title: '网上管家婆产品', // 分享标题
                      desc: '网上管家婆云进销存，网店ERP', // 分享描述
                   link: `http://${location.host}/index.html#/products?RecID=${_this.userInfo.id}&saleId=${_this.userInfo.saleId}`, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                   imgUrl: 'http://referee.zhangyuxia.com.cn/img/product1.png', // 分享图标
                })
          })
        },
      goRegister() {
          if(location.href.indexOf('stage')>-1) {
              location.href = 'http://registerstage.wsgjp.com/Template/register.html?RecID='+this.RecID+'&AgentID='+this.saleId
          } else {
              location.href = 'http://register.wsgjp.com.cn/Template/register.html?RecID='+this.RecID+'&AgentID='+this.saleId

          }
      },
    goshare() {
        this.$toast.fail({message:'点击右上角菜单分享',duration:3000})
    }
  }
  }
</script>

<style lang="less" scoped>
.products{
    .container{
        &>div{
            position: relative;
            height: 355px;
            img{
                width: 97px;
                height: 28px;
                position: absolute;
            }
        }
        .psi{
            background: url('../../assets/images/psi.png')no-repeat;
            background-size: 100%;
            img{
                bottom: 56px;
                right: 38px;
            }
        }
        .chain{
            background: url('../../assets/images/product-chain.jpg')no-repeat;
            background-size: 100%;
            img{
                bottom: 56px;
                right: 38px;
            }
        }
        .erp{
            background: url('../../assets/images/erp.png')no-repeat;
            background-size: 100%;
            img{
                bottom: 92px;
                right: 38px;
            }
        }
    }
    .bottom{
        position: fixed;
        bottom: 0;
        width: 100%;
        background: rgb(161, 3, 3);
        padding: 10px 24px;
        .bottom-btn{
            background: linear-gradient(to right, #F5251B ,#FB6149);
            font-size: 18px;
            border-radius: 50px;
            height: 48px;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            img{
                width: 18px;
                height: 18px;
                margin-right: 6px;
            }
        }
    }
}
</style>
